module.exports = __webpack_public_path__ + "img/traffic5.1bf91883.png";